exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gw-summary{display:block;width:100%}.gw-cart-summary{padding:12px}.gw-cart-summary__product{padding-top:12px;padding-bottom:12px;border-top:1px solid #d4d4d4;border-bottom:1px solid #d4d4d4;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/summary/summary.scss
// module id = RsbV
// module chunks = 1